import React, { useState, useEffect,useRef, useContext, Component } from 'react';
import { useNavigate,Link } from "react-router-dom";
import TestingHeader from './TestingHeader';
import TestingFooter from './TestingFooter';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim"; // lightweight version
import { motion, useInView, animate } from "framer-motion";
import spaceAudio from '../../assets/audio/space.mp3'; // ✅ Correct way to import audio
import scrollSound from '../../assets/audio/scroll.mp3'; // ✅ Correct way to import audio
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";

 const TestingContact = () => {


    const [hide, setHide] = useState(false);



  const bgAudioRef = useRef(null);
  const scrollAudioRef = useRef(null);
  const playedScroll = useRef(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const bg = bgAudioRef.current;
    const scrollFx = scrollAudioRef.current;
    if (!bg || !scrollFx) return;

    // ✅ Background Audio setup
    bg.loop = true;
    bg.volume = 0.2;
    bg.preload = "auto";
    bg.currentTime = 0.3;

    bg.play()
      .then(() => setIsPlaying(true))
      .catch(() => {
        console.log("Autoplay blocked — click once to start background audio.");
        const startBg = () => {
          bg.play().then(() => setIsPlaying(true)).catch(() => {});
          window.removeEventListener("click", startBg);
        };
        window.addEventListener("click", startBg);
      });

    // ✅ Scroll effect
    const playScrollFx = () => {
      if (playedScroll.current) return;
      playedScroll.current = true;
      scrollFx.currentTime = 0;
      scrollFx.volume = 0.2;
      scrollFx.play().catch(() => {});
      setTimeout(() => (playedScroll.current = false), 800);
    };

    window.addEventListener("scroll", playScrollFx);
    return () => window.removeEventListener("scroll", playScrollFx);
  }, []);

  // ✅ Toggle audio manually
  const handleToggleAudio = () => {
    const bg = bgAudioRef.current;
    const scrollFx = scrollAudioRef.current;
    if (!bg || !scrollFx) return;

    if (isPlaying) {
      bg.pause();
      scrollFx.pause();
      setIsPlaying(false);
    } else {
      bg.play().then(() => setIsPlaying(true)).catch(() => {});
      // Don’t auto-play scrollFx; it’s handled on scroll
    }
  };

    const [flipped, setFlipped] = useState(null);

    const services = [
  {
    id: 1,
    title: "Home Automation",
    img: "/assets/img/home-automation.webp",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    more: "Home automation allows you to control lights, appliances, and more with your smartphone or voice assistants."
  },
  {
    id: 2,
    title: "Security",
    img: "/assets/img/modern-lock.webp",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    more: "Our security systems include CCTV, access control, and motion sensors for full protection."
  },
  {
    id: 3,
    title: "AV Solution",
    img: "/assets/img/av-solution.webp",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    more: "AV solutions provide immersive sound and video experiences for home and office environments."
  }
];

 const [engineReady, setEngineReady] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine); // load the minimal engine
    }).then(() => {
      setEngineReady(true);
    });
  }, []);

 
  // 👇 OUTSIDE any component
const particlesOptions = {
  background: { color: { value: "white" } },
  fpsLimit: 60,
  interactivity: {
    events: {
      onHover: { enable: true, mode: "repulse" },
      onClick: { enable: true, mode: "push" },
    },
    modes: {
      repulse: { distance: 100, duration: 0.4 },
      push: { quantity: 3 },
    },
  },
  particles: {
    color: { value: "#f6ff00ff" },
    links: {
      // color: "#2d3058ff",
          color: "#ffffffff",
      distance: 120,
      enable: true,
      // opacity: 0.3,
      opacity: 1,
       width: 1,
    },
    move: {
      enable: true,
      speed: 1,
      outModes: { default: "bounce" },
    },
    number: { value: 150, density: { enable: true, area: 100 } },
    opacity: { value: 0.3 },
    shape: { type: "circle" },
    size: { value: { min: 1, max: 3 } },
  },
  detectRetina: true,
};


  function Counter({ to = 0, duration = 1.2, suffix = "", decimals = 0 }) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -20% 0px" });
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => {
        const factor = Math.pow(10, decimals);
        setValue(Math.round(v * factor) / factor);
      },
    });
    return () => controls.stop();
  }, [inView, to, duration, decimals]);

  return (
    <span ref={ref}>
      {value.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}
      {suffix}
    </span>
  );
}


const testimonialDate =[
  {
    id: 1,
    name: "Rahul Sharma",
    message:
      "Working with Altima has been an incredibly smooth and rewarding experience. Their team understood our office security requirements perfectly and suggested solutions that were both practical and advanced. The installation process was handled professionally, with clear communication at every stage. What impressed me most was the way they explained each feature and ensured we were fully comfortable using the system. Ever since the upgrade, our staff feels safer and our overall monitoring is far more efficient. I would highly recommend Altima to anyone looking for reliable and intelligent security systems.",
  },

  {
    id: 2,
    name: "Neha Verma",
    message:
      "Altima has truly exceeded our expectations. Their perimeter security solution has made a huge difference to our residential property. From the very first consultation, the team was transparent, knowledgeable, and extremely patient in answering all our questions. The quality of their equipment is top-notch and the response time has been exceptional. We’ve already noticed a major improvement in safety and awareness around our premises. Their after-sales support is just as impressive—always available, polite, and very helpful. I am extremely satisfied and confidently recommend Altima to others.",
  },

  {
    id: 3,
    name: "Amit Gupta",
    message:
      "The level of professionalism and expertise that Altima brought to our home automation project was outstanding. They handled everything from planning to installation with great attention to detail. The automation system is seamless, intuitive, and has genuinely improved our everyday comfort. Whether it’s lighting, security, or AV integration, everything works perfectly in sync. What truly sets Altima apart is the way they prioritize customer convenience—they ensure everything is simple to use and customized to your lifestyle. It was one of the best investments we made for our home.",
  },

  {
    id: 4,
    name: "Priya Singh",
    message:
      "We hired Altima for a complete AV transformation of our conference room, and the outcome was beyond impressive. The sound clarity, display quality, and overall design have elevated the professional experience for our entire team. Their engineers are highly skilled and take the time to understand the exact requirements before recommending solutions. The project was completed on time, and the training provided afterward made everything very easy to operate. Even guests who visit our office frequently compliment the setup. Altima stands out for its exceptional quality, service, and long-term reliability.",
  }
];


 
  const blogData = [
  {
    id: 1,
    image: "/assets/img/home-automation.webp",
    date: "Jan 20, 2025",
    title: "How To Trust Your Intuition When You’re Making A Decision",
    author: "Altima Global",
    link: "#"
  },
  {
    id: 2,
    image: "/assets/img/home-automation.webp",
    date: "Feb 15, 2025",
    title: "The Science of Happiness: 10 Ways to Boost Your Mood",
    author: "Altima Global",
    link: "#"
  },
  {
    id: 3,
    image: "/assets/img/home-automation.webp",
    date: "Mar 5, 2025",
    title: "Mastering Time Management for Busy People",
    author: "Altima Global",
    link: "#"
  }
];


const PARTNER_BRANDS = [
  { id: 1, name: "Brand One", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 2, name: "Brand Two", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 3, name: "Brand Three", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 4, name: "Brand Four", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 5, name: "Brand Five", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 6, name: "Brand Six", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
];

const FAQ_DATA = [
  {
    id: 1,
    question: "What kind of solutions does Altima provide?",
    answer:
      "We provide end-to-end Security, AV and Home Automation solutions including perimeter security, CCTV surveillance, access control, fire systems, auditorium AV, commercial cinema and fully integrated smart home experiences."
  },
  {
    id: 2,
    question: "Do you handle both design and installation?",
    answer:
      "Yes. Our team handles complete solution design, product selection, wiring layouts, installation, configuration and final handover. We also train your staff or family members to operate the system with ease."
  },
  {
    id: 3,
    question: "Can the systems be integrated with existing infrastructure?",
    answer:
      "In most cases, yes. We assess your current infrastructure and suggest the best way to integrate new systems with existing cabling, devices and networks to avoid unnecessary replacement costs."
  },
  {
    id: 4,
    question: "Do you provide post-installation support and maintenance?",
    answer:
      "Absolutely. We offer AMC and on-call support options. Our engineers are available for health checks, firmware upgrades, troubleshooting and future enhancements as your needs evolve."
  },
  {
    id: 5,
    question: "Do you work on residential, commercial and institutional projects?",
    answer:
      "Yes. We work with luxury homes, offices, schools, colleges, hotels, hospitals, auditoriums and industrial facilities—designing custom solutions based on the use-case and budget."
  }
];


const AWARDS = [
  {
    id: 1,
    title: "ISO 9001:2015 Certified",
    image: "/assets/img/award.png",
  },
  {
    id: 2,
    title: "Best Automation Integrator Award 2023",
    image: "/assets/img/award.png",
  },
  {
    id: 3,
    title: "Authorized Partner Certification",
    image: "/assets/img/award.png",
  },
  {
    id: 4,
    title: "Industry Excellence Badge",
    image: "/assets/img/award.png",
  },
  
];

 
 const FEATURED_PRODUCTS = [
  {
    id: 1,
    title: "Video Surveillance Systems (CCTV)",
    category: "Security",
    image: "/assets/img/home-automation.webp",
    description:
      "Hanwha • Tyco American Dynamics • Panasonic • Honeywell • ANPR Cam • Remote Monitoring – Milestone & Genetec",
  },
  {
    id: 2,
    title: "Fire Safety & Alarm Systems",
    category: "Fire & Life Safety",
    image: "/assets/img/av-solution.webp",
    description:
      "Fire Alarm System • Honeywell Fire • Simplex by Johnson Control • Verbena • Bosch Fire Alarm • PA Systems • Linear Heat Sensing for Cables",
  },
  {
    id: 3,
    title: "Home Automation Solutions",
    category: "Smart Living",
    image: "/assets/img/home-automation.webp",
    description:
      "Smart Lighting • Scene-Based Controls • Motion Sensors • App & Voice Automation • Smart Thermostats • Curtain & Blinds Automation • Wireless Networking",
  },
  {
    id: 4,
    title: "Access Control & Attendance Systems",
    category: "Access Management",
    image: "/assets/img/av-solution.webp",
    description:
      "Biometric Systems • Face Access • Iris Access • Suprema • Idemia Morpho • Time Attendance Software • Integrated Access Solutions",
  },
];



    return (
        <>
      <audio ref={bgAudioRef} src={spaceAudio} preload="auto" />
    
      {/* 🔊 short scroll sound */}
      <audio ref={scrollAudioRef} src={scrollSound} preload="auto" />

            <TestingHeader />


 <div className="hero-section py-0 position-relative overflow-hidden bg-white">
  {/* TOP: TITLE + MAP VISUAL */}
  <section className="multicolumn multicolumn-page bg-white">
    <div className="py-5">
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-lg-6 text-center text-lg-start">
            <h3 className="fw-bold mb-3 text-dark text-uppercase">
              Get in touch with <span className="text-Gradient">our team</span>
            </h3>
            <p className="text-dark mb-3">
              Revolutionizing Modern Living with Technology, Comfort, and
              Security.
            </p>
            <div className="d-flex flex-wrap gap-2 mt-3">
              <span className="badge rounded-pill bg-dark text-white px-3 py-2">
                Smart Living Solutions
              </span>
              <span className="badge rounded-pill bg-light text-muted border px-3 py-2">
                Enterprise Projects
              </span>
              <span className="badge rounded-pill bg-dark-subtle text-dark px-3 py-2">
                24/7 Support
              </span>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
              <img
                src="/assets/img/mapbg.jpg"
                className="w-100"
                alt="Altima Global office locations map"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* OFFICES WITH MAPS */}
  <div className="container pb-5">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="fw-semibold mb-0">Our Corporate Offices</h5>
      <span className="small text-muted">New Delhi · India</span>
    </div>
    <div className="row g-4">
      {/* Connaught Place */}
      <div className="col-lg-6">
        <div className="card shadow border-0 rounded-4 h-100">
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="fw-bold mb-0">
                <i className="bi bi-geo-alt-fill text-danger me-2" />
                Connaught Place Office
              </h5>
              <span className="badge rounded-pill bg-dark text-white small">
                Head Office
              </span>
            </div>
            <p className="text-muted mb-3">
              4th Floor, Statesman House Building, Barakhamba Road, Connaught
              Place, New Delhi, Delhi 110001
            </p>
            <div className="ratio ratio-16x9 rounded overflow-hidden">
              <iframe
                src="https://www.google.com/maps?q=Statesman+House+Barakhamba+Road+New+Delhi&output=embed"
                width="100%"
                height="100%"
                loading="lazy"
                style={{ border: 0 }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Jasola */}
      <div className="col-lg-6">
        <div className="card shadow border-0 rounded-4 h-100">
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="fw-bold mb-0">
                <i className="bi bi-geo-alt-fill text-primary me-2" />
                Jasola Office
              </h5>
              <span className="badge rounded-pill bg-light text-dark border small">
                Branch Office
              </span>
            </div>
            <p className="text-muted mb-3">
              Plot 25, Pocket - 2, Jasola, Behind HDFC Bank, Andhra Bank, Jasola
              Vihar, New Delhi, Delhi 110025
            </p>
            <div className="ratio ratio-16x9 rounded overflow-hidden">
              <iframe
                src="https://www.google.com/maps?q=Jasola+Vihar+New+Delhi+110025&output=embed"
                width="100%"
                height="100%"
                loading="lazy"
                style={{ border: 0 }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* CONTACT + DEPARTMENT EMAILS */}
  <section className="py-5 hero-contact-section">
    <div className="container">
      <div className="row align-items-start gy-4">
        {/* LEFT: DEPT EMAILS + TITLE */}
        <div className="col-lg-6">
          <div className="mb-3 small text-muted">●●●●●●●●●●●●●●●●●</div>
          <h1 className="display-6 fw-bold mb-3">
            For Any Query <span className="text-Gradient">Contact Us</span>
          </h1>
          <p className="text-muted mb-4">
            Reach the right team directly. Choose the department that best
            matches your query for a faster response.
          </p>
          <div className="department-list list-group shadow-sm rounded-3 mb-3">
            <div className="list-group-item py-3 d-flex justify-content-between align-items-start">
              <div>
                <h6 className="fw-semibold mb-1">
                  <i className="bi bi-people-fill text-primary me-2" />
                  HR Department
                </h6>
                <span className="text-muted">hr@altimaglobal.com</span>
              </div>
              <a
                href="mailto:hr@altimaglobal.com"
                className="btn btn-sm btn-dark rounded-pill px-3"
              >
                Email
              </a>
            </div>
            <div className="list-group-item py-3 d-flex justify-content-between align-items-start">
              <div>
                <h6 className="fw-semibold mb-1">
                  <i className="bi bi-briefcase-fill text-success me-2" />
                  Project &amp; Sales Enquiry
                </h6>
                <span className="text-muted">sales@altimaglobal.com</span>
              </div>
              <a
                href="mailto:sales@altimaglobal.com"
                className="btn btn-sm btn-dark rounded-pill px-3"
              >
                Email
              </a>
            </div>
            <div className="list-group-item py-3 d-flex justify-content-between align-items-start">
              <div>
                <h6 className="fw-semibold mb-1">
                  <i className="bi bi-cash-coin text-warning me-2" />
                  Finance &amp; Billing Enquiry
                </h6>
                <span className="text-muted">billing@altimaglobal.com</span>
              </div>
              <a
                href="mailto:billing@altimaglobal.com"
                className="btn btn-sm btn-dark rounded-pill px-3"
              >
                Email
              </a>
            </div>
            <div className="list-group-item py-3 d-flex justify-content-between align-items-start">
              <div>
                <h6 className="fw-semibold mb-1">
                  <i className="bi bi-exclamation-triangle-fill text-danger me-2" />
                  Complaints
                </h6>
                <span className="text-muted">support@altimaglobal.com</span>
              </div>
              <a
                href="mailto:support@altimaglobal.com"
                className="btn btn-sm btn-dark rounded-pill px-3"
              >
                Email
              </a>
            </div>
          </div>
          <small className="text-muted">
            Response time: <strong>within 24–48 business hours</strong>.
          </small>
        </div>
        {/* RIGHT: FORM */}
        <div className="col-lg-6">
          <div className="contact-card-wrapper rounded-4 p-1">
            <div className="bg-white bg-opacity-90 border-0 rounded-4 shadow-lg p-4 p-md-5">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-semibold mb-0">Send us a message</h5>
                <span className="badge bg-success-subtle text-success small">
                  <i className="bi bi-lightning-charge-fill me-1" /> Quick
                  Response
                </span>
              </div>
              <form>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        placeholder="James"
                      />
                      <label htmlFor="firstName">First Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        placeholder="Smith"
                      />
                      <label htmlFor="lastName">Last Name</label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="you@example.com"
                      />
                      <label htmlFor="email">Email</label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        id="message"
                        placeholder="Enter message..."
                        style={{ height: 130 }}
                        defaultValue={""}
                      />
                      <label htmlFor="message">Message</label>
                    </div>
                  </div>
                  <div className="col-12 d-flex justify-content-between align-items-center pt-2">
                    <small className="text-muted">
                      By submitting, you agree to our{" "}
                      <a href="#" className="text-decoration-underline">
                        Privacy Policy
                      </a>
                      .
                    </small>
                    <button
                      type="submit"
                      className="btn btn-dark px-4 rounded-pill"
                    >
                      Contact Us
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

           
            <TestingFooter />
        </>

    );
};

export default TestingContact